import { __decorate } from "tslib";
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { AppMessageToast } from './components';
import * as i0 from "@angular/core";
let MessagesFrontendFeature = /*#__PURE__*/(() => {
  let MessagesFrontendFeature = class MessagesFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/messages/frontend","featureId":"common-messages"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: AppMessageToast,
        excludeSSR: true,
        inputs: {
          position: "bottom-right"
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMessagesFrontendFeature_BaseFactory;
        return function MessagesFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMessagesFrontendFeature_BaseFactory || (ɵMessagesFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MessagesFrontendFeature)))(__ngFactoryType__ || MessagesFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MessagesFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [AppMessageToast]
      });
    }
  };
  MessagesFrontendFeature = __decorate([ClassName("MessagesFrontendFeature")], MessagesFrontendFeature);
  return MessagesFrontendFeature;
})();
export { MessagesFrontendFeature };